export default [
  // SERIF
  {
    family: "'Abhaya Libre', serif",
    name: "Abhaya Libre",
    type: "serif",
  },
  {
    family: "'Cormorant Garamond', serif",
    name: "Cormorant Garamond",
    type: "serif",
  },
  {
    family: "'Droid Serif', serif",
    name: "Droid Serif",
    type: "serif",
  },
  {
    family: "'Libre Baskerville', serif",
    name: "Libre Baskerville",
    type: "serif",
  },
  {
    family: "'Lora', serif",
    name: "Lora",
    type: "serif",
  },
  {
    family: "'Noto Serif', serif",
    name: "Noto Serif",
    type: "serif",
  },
  {
    family: "'Playfair Display', serif",
    name: "Playfair Display",
    type: "serif",
  },
  {
    family: "'Roboto Slab', serif",
    name: "Roboto Slab",
    type: "serif",
  },
  {
    family: "'Taviraj', serif",
    name: "Taviraj",
    type: "serif",
  },
  {
    family: "'Trirong', serif",
    name: "Trirong",
    type: "serif",
  },
  // SANS-SERIF
  {
    family: "'Lato', sans-serif",
    name: "Lato",
    type: "sans-serif",
  },
  {
    family: "'Libre Franklin', sans-serif",
    name: "Libre Franklin",
    type: "sans-serif",
  },
  {
    family: "'Lekton', sans-serif",
    name: "Lekton",
    type: "sans-serif",
  },
  {
    family: "'Maven Pro', sans-serif",
    name: "Maven Pro",
    type: "sans-serif",
  },
  {
    family: "'Montserrat', sans-serif",
    name: "Montserrat",
    type: "sans-serif",
  },
  {
    family: "'Nunito Sans', sans-serif",
    name: "Nunito Sans",
    type: "sans-serif",
  },
  {
    family: "'Open Sans', sans-serif",
    name: "Open Sans",
    type: "sans-serif",
  },
  {
    family: "'Oswald', sans-serif",
    name: "Oswald",
    type: "sans-serif",
  },
  {
    family: "'Quicksand', sans-serif",
    name: "Quicksand",
    type: "sans-serif",
  },
  {
    family: "'Raleway', sans-serif",
    name: "Raleway",
    type: "sans-serif",
  },
  {
    family: "'Roboto', sans-serif",
    name: "Roboto",
    type: "sans-serif",
  },
  {
    family: "'Rubik', sans-serif",
    name: "Rubik",
    type: "sans-serif",
  },
  {
    family: "'Titillium Web', sans-serif",
    name: "Titillium Web",
    type: "sans-serif",
  },
  {
    family: "'Work Sans', sans-serif",
    name: "Work Sans",
    type: "sans-serif",
  },
  // DISPLAY
  {
    family: "'Abril Fatface', cursive",
    name: "Abril Fatface",
    type: "cursive",
  },
  {
    family: "'Alfa Slab One', cursive",
    name: "Alfa Slab One",
    type: "cursive",
  },
  {
    family: "'Bungee Inline', cursive",
    name: "Bungee Inline",
    type: "cursive",
  },
  {
    family: "'Carter One', cursive",
    name: "Carter One",
    type: "cursive",
  },
  {
    family: "'Cherry Swash', cursive",
    name: "Cherry Swash",
    type: "cursive",
  },
  {
    family: "'Fugaz One', cursive",
    name: "Fugaz One",
    type: "cursive",
  },
  {
    family: "'Lalezar', cursive",
    name: "Lalezar",
    type: "cursive",
  },
  {
    family: "'Lobster', cursive",
    name: "Lobster",
    type: "cursive",
  },
  {
    family: "'Nova Flat', cursive",
    name: "Nova Flat",
    type: "cursive",
  },
  {
    family: "'Patua One', cursive",
    name: "Patua One",
    type: "cursive",
  },
  {
    family: "'Shrikhand', cursive",
    name: "Shrikhand",
    type: "cursive",
  },
  {
    family: "'Gruppo', cursive",
    name: "Gruppo",
    type: "cursive",
  },
  // MONOSPACE
  {
    family: "'Droid Sans Mono', monospace",
    name: "Droid Sans Mono",
    type: "monospace",
  },
  {
    family: "'Cutive Mono', monospace",
    name: "Cutive Mono",
    type: "monospace",
  },
  {
    family: "'Inconsolata', monospace",
    name: "Inconsolata",
    type: "monospace",
  },
  {
    family: "'Roboto Mono', monospace",
    name: "Roboto Mono",
    type: "monospace",
  },
  {
    family: "'Ubuntu Mono', monospace",
    name: "Ubuntu Mono",
    type: "monospace",
  },
  {
    family: "'VT323', monospace",
    name: "VT323",
    type: "monospace",
  },
  // HANDWRITING
  {
    family: "'Amatic SC', cursive",
    name: "Amatic SC",
    type: "cursive",
  },
  {
    family: "'Bad Script', cursive",
    name: "Bad Script",
    type: "cursive",
  },
  {
    family: "'Caveat', cursive",
    name: "Caveat",
    type: "cursive",
  },
  {
    family: "'Gloria Hallelujah', cursive",
    name: "Gloria Hallelujah",
    type: "cursive",
  },
  {
    family: "'Indie Flower', cursive",
    name: "Indie Flower",
    type: "cursive",
  },
  {
    family: "'Pacifico', cursive",
    name: "Pacifico",
    type: "cursive",
  },
  {
    family: "'Shadows Into Light', cursive",
    name: "Shadows Into Light",
    type: "cursive",
  },
];
